const schema = localStorage.getItem("schema")

export const basicFormData = () => ({
    inputData: {
        uom_name:"",
        created_by: "",
        updated_by: "",
        is_active: true,
    },
});

export const createPageData = () => {
    const payload = {
        modelName: "uom_masters",
        schema:schema,
        inputData: {
            role_name: "",
            created_by: "",
            updated_by: "",
            is_active: true,
        },        
    };
    const deleteRelation = [
        {
            modelName: "role_masters",
            moduleAs: "subcontractor",
            foreignKey: "subcontractor_id",
        },
        {
            modelName: "role_documents",
            moduleAs: "role_documents",
            foreignKey: "role_id",
        },
    ];

    const navigatePage = { back: "/uom-list" };

    const headerName = "uom";

    const validationType = "UOMCreate";
    const createEndpoint = "/updaterelationaldata";
    const updateEndpoint = "/updaterelationaldata";
    const getEndpoint = "/getRecords";
    
    

    return {
        payload,
        navigatePage,
        headerName,
        validationType,
        createEndpoint,
        updateEndpoint,
        getEndpoint,
        deleteRelation,
    };
};

export const listPageData = (type) => {
    const payload = {
        modelName: "uom_masters",
        schema:schema        
    };

    const columnData = [
        { label: "Sr. No", value: "index" },
        { label: "UOM Name", value: "name" },
        { label: "Status", value: "is_active" },
        { label: "Action", value: "actions" },
    ];

    const navigatePage = {
        create: "/uom-create",
        edit: "/uom-create",
        view: "/uom-view",
    };

    const searchfields = [
        "uom_masters.uom_name",
    ];

    const headerName = "UOM";
    const endpoint = "/getRecords";
    const exportFileName = "UOMData.xlsx";

    return {
        payload,
        navigatePage,
        headerName,
        columnData,
        endpoint,
        searchfields,
        exportFileName,
    };
};

export const exportPageData = {
    modelName: "uom_masters",
    schema:schema,
    whereCondition: {
        uom_id: { in: [1] },
    },

    // relations: [
    //     {
    //         module: "role_masters",
    //         moduleAs: "createdBy",
    //     },
    //     {
    //         module: "role_masters",
    //         moduleAs: "updatedBy",
    //     },
    //     {
    //         module: "role_masters",
    //         moduleAs: "subcontractor",
    //     },
    //     {
    //         module: "role_masters",
    //         moduleAs: "role_masters",
    //     },
    //     {
    //         module: "company_masters",
    //         moduleAs: "company_masters",
    //     },
    // ],
    pagination: { page: 1, pageSize: 10000 },
};
